module.exports = __webpack_public_path__ + "img/feature3.4ebe7323.png";